import fp, { pick } from "lodash/fp";
import * as Yup from "yup";
import { IVendorFieldsFragment } from "~/lib/queries/fragments/__generated__/VendorFields.generated";
import prefixWithHttpIfNecessary from "~/lib/utils/prefixWithHttpIfNecessary";
import urlRegex from "~/lib/utils/urlRegex";

interface IEditVendorFormInput extends IVendorFieldsFragment {
  contact: any;
}

export default function convertValuesToVariables(values: IEditVendorFormInput): any {
  return {
    name: values.name || null,
    billingName: values.billingName || null,
    description: values.description || null,
    yearFounded: Number(values.yearFounded) || null,
    site: prefixWithHttpIfNecessary(values.site),
    headquarters: values.headquarters || null,
    slogan: values.slogan || null,
    contactPage: getContactPage(values.contact) || null,
    businessEmail: getBusinessEmail(values.contact) || null,
    highlights: fp.uniq(values.highlights.map(fp.trim).filter(Boolean)) || null,
    newsworthy: values.newsworthy || null,
    logo: values.logo || null,
    socialMedia: fp.pick(["facebook", "instagram", "linkedin", "twitter", "youtube"], values.socialMedia) || null,
    numberOfEmployees: fp.get("numberOfEmployees.value", values) || null,
    cover: null,
    resources: (values.resources || []).map(pick(["type", "url", "title", "body"])),
  };
}

function getContactPage(contact: string | null) {
  if (!contact) {
    return null;
  }

  const urlSchema = Yup.string().matches(urlRegex);

  try {
    urlSchema.validateSync(contact);

    return prefixWithHttpIfNecessary(contact);
  } catch {
    return null;
  }
}

function getBusinessEmail(contact: string | null) {
  if (!contact) {
    return null;
  }

  const emailSchema = Yup.string().email();

  try {
    emailSchema.validateSync(contact);

    return contact;
  } catch {
    return null;
  }
}
